import { get, writable, Writable } from "svelte/store";
import type { RetailerContextType } from "@shared/types/Retailer";
import * as _ from "lodash";
import * as Sentry from "@sentry/browser";
import CurrentRetailerStore from "@retailer/svelte/stores/CurrentRetailerStore";
import { loadPunchoutSession } from "@retailer/services/punchout_session_service";

var LAST_CONTEXT_KEY = "X-Tiz-Last-Retailer-Context";
var CONTEXT_KEY = "X-Tiz-Retailer-Context";

var service = function () {
  let context: RetailerContextType = { currentRetailerId: null, retailers: [] };
  let retailerContextStore: Writable<RetailerContextType>;
  if (!window["$rootScope"]) {
    window["$rootScope"] = {};
  }

  function initialize(incomingRetailers) {
    if (incomingRetailers) {
      context.retailers = incomingRetailers;
    } else {
      context.retailers = window["PRELOADED_RETAILERS"];
    }

    const retailerIds = context.retailers.map(retailer => retailer.id);
    const currentRetailerOverrideId = window["CURRENT_RETAILER_OVERRIDE_ID"];
    const savedId = pullFromStorage();

    let idToSet = null;

    if (currentRetailerOverrideId && retailerIds.includes(currentRetailerOverrideId)) {
      idToSet = currentRetailerOverrideId;
    } else if (savedId && retailerIds.includes(savedId)) {
      idToSet = savedId;
    } else if (retailerIds.length > 0) {
      idToSet = retailerIds[0];
    }

    context.currentRetailerId = idToSet;

    if (idToSet && idToSet !== savedId) {
      persistToStorage(idToSet);
    }

    retailerContextStore = writable<RetailerContextType>(context);
    // regrettable but temporary:
    window["$rootScope"].getCurrentRetailer = function () {
      for (var i = 0; i < context.retailers.length; i++) {
        if (context.retailers[i].id == context.currentRetailerId) return context.retailers[i];
      }
    };
    window["$rootScope"].retailers = context.retailers;
    window["$rootScope"].currentRetailerId = context.currentRetailerId;
    setSentryContext();

    afterInitialize();
  }

  function afterInitialize() {
    const currentRetailer = getCurrentRetailer();

    if (currentRetailer?.has_punchout) {
      loadPunchoutSession();
    }
  }

  function persistToStorage(id) {
    localStorage.setItem(LAST_CONTEXT_KEY, id);
    sessionStorage.setItem(CONTEXT_KEY, id);
  }

  function setRetailer(id) {
    persistToStorage(id);
    retailerContextStore.update(context => ({
      currentRetailerId: id,
      retailers: context.retailers,
    }));
  }

  function getCurrentRetailer() {
    const { retailers, currentRetailerId } = get(retailerContextStore) || context;
    return retailers.find(retailer => retailer.id === currentRetailerId);
  }

  function getCurrent() {
    CurrentRetailerStore.set(getCurrentRetailer());
    return get(CurrentRetailerStore);
  }

  function getAll() {
    return get(retailerContextStore).retailers;
  }

  function setSentryContext() {
    var retailer = getCurrent();
    Sentry.setContext("retailer", _.pick(retailer, ["id", "name", "state"]));
  }

  function pullFromStorage() {
    const savedId = sessionStorage.getItem(CONTEXT_KEY) || localStorage.getItem(LAST_CONTEXT_KEY);
    if (savedId) return Number(savedId);
  }

  return {
    initialize: initialize,
    get: getCurrent,
    getAllRetailers: getAll,
    setAndGo: function (id) {
      setRetailer(id);
      if (_.includes(location.href, "/orders")) {
        window.location.assign("/orders");
      } else if (_.includes(location.href, "/lists")) {
        window.location.assign("/lists");
      } else {
        location.reload();
      }
    },
    setRetailer: function (id) {
      setRetailer(id);
      if (_.includes(location.href, "/orders")) {
        window.location.assign("/orders");
      } else if (_.includes(location.href, "/lists")) {
        window.location.assign("/lists");
      } else {
        location.reload();
      }
    },
  };
};
const retailerContext = service();
export default retailerContext;
